"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const models_1 = require("app/models");
const firestore_web_1 = require("comodel/firestore-web");
const mingo_1 = require("mingo");
const standard_1 = require("react-hook-schema/standard");
const components_1 = require("utils/components");
const FindReplaceForm_1 = __importDefault(require("./FindReplaceForm"));
const FindResult_1 = __importDefault(require("./FindResult"));
const index_1 = require("../../../../../../../index");
const log_1 = require("common/log");
function FindReplacePanel({ projectId, segmentId, langId, scriptList, }) {
    const alert = (0, standard_1.useAlert)();
    const [matchedScripts, setMatchedScripts] = (0, react_1.useState)([]);
    const navigate = (0, index_1.useTypedNavigate)();
    const [target, setTarget] = (0, react_1.useState)("translated");
    const [searchValue, setSearchValue] = (0, react_1.useState)("");
    const [replaceValue, setReplaceValue] = (0, react_1.useState)("");
    const [selectedScriptIndex, setSelectedScriptIndex] = (0, react_1.useState)(0);
    const errorModal = (0, standard_1.useErrorModal)();
    const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId }, {
        filter: { segmentId },
    });
    const navigateToScript = (scriptId) => navigate("UPDATE_SEGMENT_SCRIPT", { scriptId, projectId, segmentId }, { retainSearchParams: true });
    const handleSelectScript = (script, index) => {
        setSelectedScriptIndex(index);
        navigateToScript(script.scriptId);
    };
    const handleIgnore = () => {
        if (!matchedScripts.length)
            return;
        setSelectedScriptIndex((prev) => {
            let next = prev;
            if (prev + 1 < matchedScripts.length) {
                next = prev + 1;
            }
            else {
                next = 0;
            }
            navigateToScript(matchedScripts[next].scriptId);
            return next;
        });
    };
    const handleSearch = (value, target) => {
        setSearchValue(value);
        setTarget(target);
        let results = [];
        if (value) {
            let queryField = "";
            if (target === "translated") {
                queryField = `translations.${langId}`;
            }
            else if (target === "original") {
                queryField = "text";
            }
            const mingoQuery = new mingo_1.Query({
                [queryField]: {
                    $regex: value,
                },
            });
            results = scriptList.filter((s) => mingoQuery.test(s));
        }
        if (results.length) {
            setSelectedScriptIndex(0);
            navigateToScript(results[0].scriptId);
        }
        setMatchedScripts(results);
    };
    const handleReplace = (values) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const { target, searchValue, replaceValue } = values;
        const targetScript = matchedScripts[selectedScriptIndex];
        // Replace translations
        if (target === "translated") {
            const regex = new RegExp(searchValue, "gi");
            const updated = (_a = targetScript.translations) === null || _a === void 0 ? void 0 : _a[langId].replaceAll(regex, replaceValue);
            try {
                yield accessor.upsert(Object.assign(Object.assign({}, targetScript), { translations: {
                        [langId]: updated,
                    } }));
                navigateToScript(matchedScripts[selectedScriptIndex].scriptId);
            }
            catch (error) {
                errorModal({
                    error: error,
                    internalMessage: "Uncaught Error in Find Replace Feature",
                    userMessage: "置換操作に失敗しました。データベースへ更新データを送信する処理に失敗しています。もう一度お試しください。",
                });
            }
        }
        // Replace original text
        if (target === "original") {
            try {
                const regex = new RegExp(searchValue, "gi");
                const updated = (_b = targetScript.text) === null || _b === void 0 ? void 0 : _b.replaceAll(regex, replaceValue);
                yield accessor.upsert(Object.assign(Object.assign({}, targetScript), { text: updated }));
            }
            catch (error) {
                errorModal({
                    error: error,
                    internalMessage: "Uncaught Error in Find Replace Feature",
                    userMessage: "置換操作に失敗しました。データベースへ更新データを送信する処理に失敗しています。もう一度お試しください。",
                });
                (0, log_1.errorLog)(error);
                console.error("Uncaught Error in Find Replace Feature", error);
            }
        }
        // Move to next script
        if (selectedScriptIndex + 1 < matchedScripts.length) {
            navigateToScript(matchedScripts[selectedScriptIndex + 1].scriptId);
        }
        else {
            setSelectedScriptIndex(0);
            navigateToScript(matchedScripts[0].scriptId);
        }
        // Remove from matched list
        setMatchedScripts((prev) => [
            ...prev.slice(0, selectedScriptIndex),
            ...prev.slice(selectedScriptIndex + 1),
        ]);
    });
    (0, react_1.useEffect)(() => {
        if (matchedScripts.length) {
            navigateToScript(matchedScripts[selectedScriptIndex].scriptId);
        }
    }, [selectedScriptIndex, matchedScripts]);
    return (react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-find-replace", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u691C\u7D22\u3068\u7F6E\u63DB" }), kind: "find-replace", priority: 6 },
        react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u691C\u7D22\u3068\u7F6E\u63DB"),
        react_1.default.createElement(FindReplaceForm_1.default, { onReplace: handleReplace, onIgnore: handleIgnore, onSearch: handleSearch, onReplaceValueChange: (value) => setReplaceValue(value), matchedScripts: matchedScripts }),
        react_1.default.createElement("section", null,
            react_1.default.createElement("ul", null, matchedScripts.map((script, index) => {
                var _a, _b;
                return (react_1.default.createElement(FindResult_1.default, { key: script.scriptId, selected: ((_a = matchedScripts[selectedScriptIndex]) === null || _a === void 0 ? void 0 : _a.scriptId) ===
                        script.scriptId, onClick: () => handleSelectScript(script, index), content: target === "translated"
                        ? (_b = script.translations) === null || _b === void 0 ? void 0 : _b[langId]
                        : script.text, searchValue: searchValue, replaceValue: replaceValue }));
            })))));
}
exports.default = FindReplacePanel;
